import type { ITrainingMaterial } from '@/models/training_material'
import { TrainingMaterial } from '@/models/training_material'
import trainingMaterialService from '@/services/training_material/training-material'
import { defineStore } from 'pinia'
import type { ITrainingMaterialState } from './training-material.types'

export const useTrainingMaterialStore = defineStore('trainingMaterial', {
  state: (): ITrainingMaterialState => ({
    trainingMaterials: []
  }),
  getters: {
    getTrainingMaterials(state: ITrainingMaterialState): ITrainingMaterial[] {
      return state.trainingMaterials.map((trainingMaterial) => new TrainingMaterial(trainingMaterial))
    }
  },

  actions: {
    async fetchTrainingMaterials() {
      const trainingMaterials = await trainingMaterialService.fetchTrainingMaterials()
      this.trainingMaterials = trainingMaterials
    }
  }
})
